import React from 'react';
import { IMaskInput } from 'react-imask';

const SusepInput = ({ disabled = false, label, name, value, onChange, required = false }) => {
  const handleAccept = (val) => {
    onChange({ target: { name, value: val } });
  };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}
          {required && <span className="ml-1.5">*</span>}
        </label>
      )}

      <IMaskInput
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        value={value}
        mask="00000.000000/0000-00"
        onAccept={handleAccept}
        className="w-full border rounded-xl px-3 py-3 text-base placeholder-blueSteel border-bluePale"
      />
    </div>
  );
};

export default SusepInput;
